import { Injectable } from "@angular/core";
import { Jurisdiction } from "@obg/core.config";
import { head, map as lodashMap, unescape } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CommonContentClient } from "../content/common-content.client";

import { PRODUCT_LINK_DOCUMENT_NAME } from "./product-link.const";
import { ProductLink, ProductLinkResponseItem } from "./product-link.model";

@Injectable({
	providedIn: "root",
})
export class ProductLinkService {
	constructor(private service: CommonContentClient) {}

	get(searchParams?: { isLoggedIn: boolean; jurisdiction: Jurisdiction | undefined }): Observable<ProductLink[]> {
		return this.service
			.getCommonContent(PRODUCT_LINK_DOCUMENT_NAME, searchParams)
			.pipe(map((result) => lodashMap(result, (item) => this.processProductLink(item))));
	}

	private processProductLink(rawItem: ProductLinkResponseItem): ProductLink {
		const content = rawItem.content;
		return {
			key: rawItem.documentKey,
			image: head(content.image),
			title: unescape(head(content.title)),
			ctaUrl: head(content.ctaUrl),
			ctaLabel: head(content.ctaLabel),
			description: unescape(head(content.description)),
			termsAndConditions: unescape(head(content.termsAndConditions)),
		};
	}
}
